import React, { useEffect, useState } from 'react';
import { IonCard, IonCardHeader } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { AxiosResponse } from 'axios';
import Dialog from '@material-ui/core/Dialog';
import ClearIcon from '@material-ui/icons/Clear';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import API from '../../api/index';
import { RootState } from '../../models/RootState';
import { GapGame } from '../../models/dc/DcGame';
import { getCurrencyTypeFromToken } from '../../store';
import { BRAND_NAME } from '../../constants/Branding';
import { ShowCasinoModal } from '../../constants/WhitelabelConfig';
import '../Casino/CasinoNew/CasinoNew.scss';
import API_V2 from '../../api-services/svls-api';

type StoreProps = {
  loggedIn: boolean;
  loggedInUserStatus: any;
};

const TVGamesView: React.FC<StoreProps> = (props) => {
  const [games, setGames] = useState<GapGame[]>([]);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(
    ShowCasinoModal[BRAND_NAME] !== false &&
      Number(getCurrencyTypeFromToken()) !== 2
  );

  const { loggedIn, loggedInUserStatus } = props;
  const history = useHistory();

  const setDialogShow = (show: boolean) => {
    setShowDialog(show);
  };

  const getDcGames = async () => {
    const response: any = await API_V2.get('/catalog/v2/categories/indian-casino/games/', {
      params: {
        providerId: '*',
      },
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
      },
    });
    setGames(response.data);
  };

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      // status check
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        history.push(`/home`);
      }
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/gap_casino/game/${gameName
            .toLowerCase()
            .replace(/\s+/g, '-')}-${btoa(gameId.toString())}-${btoa(
            gameCode
          )}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setDialogShow(true);
    }
  };

  const handleGameClick = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    subProvider: string,
    provider?: string
  ) => {
    console.log(getCurrencyTypeFromToken());
    if (
      getCurrencyTypeFromToken() === 0 &&
      !(
        provider.toLocaleLowerCase() === 'ezugi' ||
        subProvider === 'BetGames.TV' ||
        subProvider === 'Pragmatic Play' ||
        subProvider === 'Pragmatic Play Live' ||
        subProvider === 'Onetouch Live' ||
        subProvider === 'OneTouch'
      )
    ) {
      setOpenDialog(true);
    } else {
      getGameUrl(gameId, gameName, gameCode, provider, subProvider);
    }
  };

  useEffect(() => {
    getDcGames();
  }, []);

  let betGamesList = games.filter((g) => g.subProviderName === 'BetGames.TV');

  return (
    <div className="dc-page-bg">
      <div className="dc-ctn">
        {betGamesList && betGamesList.length > 0 ? (
          <div className="dc-games-ctn">
            {betGamesList.map((g, i) => (
              <IonCard
                className="dc-ion-card"
                key={i}
                onClick={() =>
                  handleGameClick(
                    g.gameId,
                    g.gameName,
                    g.gameCode,
                    g.subProviderName,
                    g.providerName
                  )
                }
              >
                <IonCardHeader className="dc-card-ctn">
                  <img
                    src={g.urlThumb ? g.urlThumb : ''}
                    alt={g.gameName}
                    className="dc-img"
                  />
                </IonCardHeader>
              </IonCard>
            ))}
          </div>
        ) : null}
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setDialogShow(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => setDialogShow(false)}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          <div className="dialog-title">Notice</div>
          <div className="dialog-body">You have to be logged in to play</div>

          <div className="dialog-continue" onClick={() => setDialogShow(false)}>
            <div className="custom-btn btn">OK</div>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => setOpenDialog(false)}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>
          <div className="dialog-title">
            <StarBorderRoundedIcon />
            Live Casino Info
            <StarBorderRoundedIcon />
          </div>
          <div className="dialog-body">
            {getCurrencyTypeFromToken() === 0 ? (
              <>
                Live Casino Point is equal to 100 Normal Points.
                <div className="dialog-ex">
                  {' '}
                  Ex: 100 Casino Points = 10000 Points
                </div>{' '}
                <div className="dialog-ex">
                  Maximum Bet Limit For All Games is 5000
                </div>
              </>
            ) : null}

            {getCurrencyTypeFromToken() === 1 ? (
              <div className="dialog-ex">
                {' '}
                Maximum Bet Limit For All Games is 5000
              </div>
            ) : null}
          </div>
          <div className="dialog-continue" onClick={() => setOpenDialog(false)}>
            <div className="custom-btn btn">Continue</div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    loggedInUserStatus: status,
  };
};

export default connect(mapStateToProps, null)(TVGamesView);
